var render = function render(){var _vm=this,_c=_vm._self._c;return _c('process-directory',{attrs:{"type":1,"title":"Recuperações judiciais","route-base":"/recuperacao-judicial"}})
}
var staticRenderFns = []

export { render, staticRenderFns }